import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21;

import { action, computed, makeObservable // makeObservable,
, observable, runInAction } from "mobx"; // import Messages from "../Messages";
// import AnalyticsModel from "./AnalyticsModel";

import * as yup from "yup";
import BrandRules from "../../utils/BrandRules";

var _SCHEMA = yup.object({
  firstName: yup.string().trim().min(2, "Minimum 2 characters required").max(32, "Maximum characters allowed are 32").required("This field is mandatory"),
  lastName: yup.string().trim().min(2, "Minimum 2 characters required").max(32, "Maximum characters allowed are 32").required("This field is mandatory"),
  email: yup.string().email("Valid email required").required("This field is mandatory"),
  zipCode: yup.string().min(5, "Valid zipcode required").matches(/^[a-zA-Z0-9]*$/, "Valid zipcode required").required("This field is mandatory")
});

var _UNSUB_SCHEMA = yup.object({
  unsubEmail: yup.string().email("Valid email required").required("This field is mandatory")
});

export var JoinEclubModel = (_class = /*#__PURE__*/function () {
  //JOINECLUBFORM
  // private _appMessages: Messages;
  // private _analyticsModel: AnalyticsModel;
  function JoinEclubModel() {
    _classCallCheck(this, JoinEclubModel);

    _initializerDefineProperty(this, "_userInfo", _descriptor, this);

    _initializerDefineProperty(this, "_signUpSource", _descriptor2, this);

    _initializerDefineProperty(this, "_subscriptionStatus", _descriptor3, this);

    _initializerDefineProperty(this, "_secondarySubscriptions", _descriptor4, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor5, this);

    _initializerDefineProperty(this, "_joinEclubContainerRefs", _descriptor6, this);

    _initializerDefineProperty(this, "_isChangeLocationModalOpen", _descriptor7, this);

    _initializerDefineProperty(this, "_errObj", _descriptor8, this);

    _initializerDefineProperty(this, "_isFromAppPunchout", _descriptor9, this);

    _initializerDefineProperty(this, "_email", _descriptor10, this);

    _initializerDefineProperty(this, "_firstName", _descriptor11, this);

    _initializerDefineProperty(this, "_lastName", _descriptor12, this);

    _initializerDefineProperty(this, "_zipCode", _descriptor13, this);

    _initializerDefineProperty(this, "_dob", _descriptor14, this);

    _initializerDefineProperty(this, "_isSubmitClicked", _descriptor15, this);

    _initializerDefineProperty(this, "_isUnsubscribeSubmitClicked", _descriptor16, this);

    _initializerDefineProperty(this, "_selectedLocationState", _descriptor17, this);

    _initializerDefineProperty(this, "_isLocationsListLoading", _descriptor18, this);

    _initializerDefineProperty(this, "_preferredLocationDetails", _descriptor19, this);

    _initializerDefineProperty(this, "_unsubEmail", _descriptor20, this);

    _initializerDefineProperty(this, "_hasUnsubscribedSuccessfully", _descriptor21, this);

    makeObservable(this);
  }

  _createClass(JoinEclubModel, [{
    key: "setAppAttributes",
    value: function setAppAttributes(appAttributes) {
      this._appAttributes = appAttributes;
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "isUnsubValid",
    get: function get() {
      return _UNSUB_SCHEMA.isValidSync(this);
    }
  }, {
    key: "unsubErrors",
    get: function get() {
      var errObj = {};

      try {
        _UNSUB_SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "errObj",
    get: function get() {
      return this._errObj;
    },
    set: function set(errObj) {
      var _this = this;

      runInAction(function () {
        _this._errObj = errObj;
      });
    }
  }, {
    key: "signUpSource",
    get: function get() {
      return this._signUpSource;
    },
    set: function set(signUpSource) {
      var _this2 = this;

      runInAction(function () {
        _this2._signUpSource = signUpSource;
      });
    }
  }, {
    key: "userInfo",
    get: function get() {
      return this._userInfo;
    },
    set: function set(userInfo) {
      var _this3 = this;

      runInAction(function () {
        _this3._userInfo = userInfo;
      });
    }
  }, {
    key: "subscriptionStatus",
    get: function get() {
      return this._subscriptionStatus;
    },
    set: function set(subscriptionStatus) {
      var _this4 = this;

      runInAction(function () {
        _this4._subscriptionStatus = subscriptionStatus;
      });
    }
  }, {
    key: "secondarySubscriptions",
    get: function get() {
      return this._secondarySubscriptions;
    }
  }, {
    key: "setSecondarySubscriptions",
    set: function set(secondarySubscriptions) {
      var _this5 = this;

      runInAction(function () {
        _this5._secondarySubscriptions = secondarySubscriptions;
      });
    }
  }, {
    key: "eclubExternalURL",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$;

      return (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.subscribeExternalUrl;
    }
  }, {
    key: "showEclubField",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3;

      return ((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.configs) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.enableEclubField) === "true";
    }
  }, {
    key: "hideRestOfTheBrands",
    get: function get() {
      var _this$_appAttributes4, _this$_appAttributes5;

      return ((_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.configs) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.hideRestOfTheBrands) === "true";
    }
  }, {
    key: "secondarySignupSources",
    get: function get() {
      var _this$_appAttributes6, _this$_appAttributes7;

      var sourcesString = (_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : (_this$_appAttributes7 = _this$_appAttributes6.configs) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7["orderconf-secondary-signup"];
      var sources = sourcesString === null || sourcesString === void 0 ? void 0 : sourcesString.split(",");

      if (sources) {
        return sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
          var _source, _brandNameRegex$exec;

          source = (_source = source) === null || _source === void 0 ? void 0 : _source.replace(/["']/g, "");
          var brandNameRegex = /general-(.*)-[lL]ogo/;
          var brandName = (_brandNameRegex$exec = brandNameRegex.exec(source)) === null || _brandNameRegex$exec === void 0 ? void 0 : _brandNameRegex$exec[1];
          return {
            clubName: source,
            imageName: "".concat(brandName, "-club")
          };
        });
      }

      return [];
    }
  }, {
    key: "firstName",
    get: function get() {
      return this._firstName;
    },
    set: function set(name) {
      var _this6 = this;

      runInAction(function () {
        _this6._firstName = name;
      });
    }
  }, {
    key: "lastName",
    get: function get() {
      return this._lastName;
    },
    set: function set(name) {
      var _this7 = this;

      runInAction(function () {
        _this7._lastName = name;
      });
    }
  }, {
    key: "email",
    get: function get() {
      return this._email;
    },
    set: function set(val) {
      var _this8 = this;

      runInAction(function () {
        _this8._email = val;
      });
    }
  }, {
    key: "zipCode",
    get: function get() {
      return this._zipCode;
    },
    set: function set(val) {
      var _this9 = this; // Remove whitespace from the input value


      var strippedVal = val ? val.split(" ").join("") : val; // Regular expression to match only alphanumeric characters

      var regex = /^[a-zA-Z0-9]*$/;

      if (!strippedVal.match(regex)) {
        return;
      } // Check if the input is a number


      var isNumeric = !isNaN(Number(strippedVal)); //Modify max length for US & CA accordingly

      var maxLength = isNumeric ? 5 : 7;

      if (strippedVal.length > maxLength) {
        runInAction(function () {
          _this9._zipCode = strippedVal.slice(0, maxLength);
        });
      } else {
        runInAction(function () {
          _this9._zipCode = strippedVal;
        });
      }
    }
  }, {
    key: "isSubmitClicked",
    get: function get() {
      return this._isSubmitClicked;
    },
    set: function set(val) {
      var _this10 = this;

      runInAction(function () {
        _this10._isSubmitClicked = val;
      });
    }
  }, {
    key: "joinEclubContainerRefs",
    get: function get() {
      return this._joinEclubContainerRefs;
    },
    set: function set(_ref) {
      this._joinEclubContainerRefs = _ref;
    }
  }, {
    key: "dob",
    get: function get() {
      return this._dob;
    },
    set: function set(dob) {
      var _this11 = this;

      runInAction(function () {
        _this11._dob = dob;
      });
    }
  }, {
    key: "isChangeLocationModalOpen",
    get: function get() {
      return this._isChangeLocationModalOpen;
    },
    set: function set(value) {
      var _this12 = this;

      runInAction(function () {
        _this12._isChangeLocationModalOpen = value;
      });
    }
  }, {
    key: "selectedLocationState",
    set: function set(value) {
      var _this13 = this;

      runInAction(function () {
        _this13._selectedLocationState = value;
      });
    },
    get: function get() {
      return this._selectedLocationState;
    }
  }, {
    key: "isLocationsListLoading",
    get: function get() {
      return this._isLocationsListLoading;
    },
    set: function set(value) {
      var _this14 = this;

      runInAction(function () {
        _this14._isLocationsListLoading = value;
      });
    }
  }, {
    key: "preferredLocationDetails",
    get: function get() {
      return this._preferredLocationDetails;
    },
    set: function set(preferredLocationDetails) {
      var _this15 = this;

      runInAction(function () {
        _this15._preferredLocationDetails = preferredLocationDetails;
      });
    } //UNSUBSCRIBE

  }, {
    key: "unsubEmail",
    get: function get() {
      return this._unsubEmail;
    },
    set: function set(unsubEmail) {
      var _this16 = this;

      runInAction(function () {
        _this16._unsubEmail = unsubEmail;
      });
    }
  }, {
    key: "isUnsubscribeSubmitClicked",
    get: function get() {
      return this._isUnsubscribeSubmitClicked;
    },
    set: function set(val) {
      var _this17 = this;

      runInAction(function () {
        _this17._isUnsubscribeSubmitClicked = val;
      });
    }
  }, {
    key: "hasUnsubscribedSuccessfully",
    get: function get() {
      return this._hasUnsubscribedSuccessfully;
    },
    set: function set(val) {
      var _this18 = this;

      runInAction(function () {
        _this18._hasUnsubscribedSuccessfully = val;
      });
    }
  }, {
    key: "isFromAppPunchout",
    get: function get() {
      return this._isFromAppPunchout;
    },
    set: function set(value) {
      var _this19 = this;

      runInAction(function () {
        _this19._isFromAppPunchout = value;
      });
    }
  }, {
    key: "showBackgroundBuildingImage",
    get: function get() {
      var _BrandRules, _this$_appAttributes8;

      return (_BrandRules = new BrandRules((_this$_appAttributes8 = this._appAttributes) === null || _this$_appAttributes8 === void 0 ? void 0 : _this$_appAttributes8.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.showBackgroundBuildingImage();
    }
  }, {
    key: "joinEclubMobileSMSUrl",
    get: function get() {
      var _BrandRules2, _this$_appAttributes9;

      return (_BrandRules2 = new BrandRules((_this$_appAttributes9 = this._appAttributes) === null || _this$_appAttributes9 === void 0 ? void 0 : _this$_appAttributes9.currentConceptCode)) === null || _BrandRules2 === void 0 ? void 0 : _BrandRules2.joinEclubMobileSMSUrl();
    }
  }]);

  return JoinEclubModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_userInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_signUpSource", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_subscriptionStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_secondarySubscriptions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_joinEclubContainerRefs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_isChangeLocationModalOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_errObj", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_isFromAppPunchout", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_email", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_firstName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_lastName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_zipCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_dob", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_isSubmitClicked", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_isUnsubscribeSubmitClicked", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_selectedLocationState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "all";
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_isLocationsListLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_preferredLocationDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_unsubEmail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_hasUnsubscribedSuccessfully", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setAppAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAppAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUnsubValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUnsubValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unsubErrors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unsubErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errObj", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errObj"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "signUpSource", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "signUpSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subscriptionStatus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subscriptionStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySubscriptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySubscriptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eclubExternalURL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eclubExternalURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showEclubField", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showEclubField"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideRestOfTheBrands", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideRestOfTheBrands"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySignupSources", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySignupSources"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "email", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "email"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "zipCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "zipCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSubmitClicked", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSubmitClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "joinEclubContainerRefs", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "joinEclubContainerRefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dob", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dob"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isChangeLocationModalOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isChangeLocationModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLocationsListLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLocationsListLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preferredLocationDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preferredLocationDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unsubEmail", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unsubEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUnsubscribeSubmitClicked", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUnsubscribeSubmitClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUnsubscribedSuccessfully", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUnsubscribedSuccessfully"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showBackgroundBuildingImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showBackgroundBuildingImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "joinEclubMobileSMSUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "joinEclubMobileSMSUrl"), _class.prototype)), _class);